/**
 * @param {import("../../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/users",
    },
    (router) => {
      router.group(
        {
          path: "/:userId",
        },
        (router) => {
          router.group(
            {
              path: "/action",
            },
            (router) => {
              router.push({
                id: "@api-legacy/user@avatar",
                path: "/avatar",
              });
            },
          );
        },
      );

      router.push({
        id: "@api-legacy/user@login",
        path: "/login",
      });

      router.group(
        {
          path: "/action",
        },
        (router) => {
          router.push({
            id: "@api-legacy/user@switch-and-redirect",
            path: "/switch-and-redirect",
          });

          router.push({
            id: "@api-legacy/user@email",
            path: "/email/:email",
          });
        },
      );
    },
  );
}
